import { registerStore, connect } from "./storeConnect";
import { FooterStore } from "./FooterStore";
import { HeaderStore } from "./HeaderStore";
import { SessionStore } from "../uidispatcherapi/SessionStore";
export function connectWithDefaultStores<P>(spec, component: React.ComponentType<P>) {
	// Register stores to be used with storeConnect
	registerStore("SessionStore", SessionStore);
	registerStore("FooterStore", FooterStore);
	registerStore("HeaderStore", HeaderStore);
	return connect(spec, component);
}
